import React from 'react'
import { observer } from 'mobx-react'
import usePortManager from '../hooks/use-port-manager'
import SVGIcon from '../helpers/icons'
import usePriceManager from '../hooks/use-price-manager'
import useNavigationManager from '../hooks/use-navigation-manager'

function AddButton (props) {

  const manager = usePortManager()
  const price_manager = usePriceManager()
  const nav_manager = useNavigationManager()

  const addPort = function () {
    manager.addPort(true)
    price_manager.updatePrice()
    nav_manager.setStep(manager.getLastAccesibleStep())
  }

  return (
    <button className={'add icon-button'} onClick={() => addPort()}><SVGIcon type={'add'} fill={'#ADADAD'}/></button>
  )
}

export default observer(AddButton)